<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <section class="">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card table-card m-b-30 shadow">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-user-plus" style="font-size:13px;"></i></div>
                  <div>
                    <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Add Enrollee Form</p>
                    <small style="color:rgba(255,255,255,.7);">
                      All fields marked with <span class="text-warning">*</span> are compulsory
                    </small>
                  </div>
                </div>
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="info-label d-block mb-1" for="inputCity"
                            >Select Sector
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="sector"
                            disabled
                          >
                            <option value="formal">Formal Sector</option>
                            <option value="informal">Informal Sector</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="info-label d-block mb-1" for="inputCity"
                            >Select Plan Type
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="register.plan_type"
                          >
                            <option value="Family">Family</option>
                            <option value="Individual">Individual</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6" v-if="sector == 'informal'">
                        <div class="form-group">
                          <label class="info-label d-block mb-1" for="inputCity"
                            >Select Informal Sector
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="register.sector"
                          >
                            <option value="Basic Healthcare Provision Fund">
                              Basic Healthcare Provision Fund
                            </option>
                            <option value="State Equity Program">
                              State Equity Program
                            </option>

                            <option value="Voluntary Contributor">
                              Voluntary Contributor
                            </option>

                            <!-- <option
                              value="Community Based Health Insurance Program (CBHI)"
                            >
                              Community Based Health Insurance Program (CBHI)
                            </option> -->
                            <!-- <option
                              value="Group Individual and family support Health Insurance program (GIFSHIP)"
                            >
                              Group Individual and family support Health
                              Insurance program (GIFSHIP)
                            </option> -->
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-12">
                        <label class="info-label d-block mb-1">Special Needs</label>
                        <select
                          class="form-control"
                          v-model="register.category_of_vulnerable_group"
                        >
                          <option value="Pregnant Women">Pregnant Women</option>
                          <option value="Children under 5">
                            Children under 5
                          </option>
                          <option value="Aged">Aged</option>
                          <option value="People with Special Needs">
                            People with Special Needs
                          </option>
                          <option value="Poorest of the Poor">
                            Poorest of the Poor
                          </option>

                          <option value="State Pensioners">State Pensioners</option>
                          <option value="LGA Pensioners">LGA Pensioners</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4">NIN Number <span class="text-danger">*</span></label>
                        <input
                          required
                          type="text"
                          inputmode="numeric"
                          pattern="\d{11}"
                          maxlength="11"
                          class="form-control"
                          v-model="register.nimc_number"
                          @input="register.nimc_number = register.nimc_number.replace(/\D/g, '').slice(0, 11)"
                          placeholder="NIN Number"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Surname <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.lastname"
                          placeholder="Last Name"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.firstname"
                          placeholder="First Name"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4">Middle Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.middlename"
                          placeholder="Middle Name"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Date of Birth<span class="text-danger">*</span>
                        </label>
                        <small v-if="isChildUnder5Category" class="text-info d-block mb-1">
                          Must be under 5 years old
                        </small>
                        <small v-else-if="isAgedCategory" class="text-info d-block mb-1">
                          Must be 60 years or older
                        </small>
                        <small v-else-if="isPregnantCategory" class="text-info d-block mb-1">
                          Must be at least 13 years old
                        </small>
                        <input
                          type="date"
                          :min="dobMin"
                          :max="dobMax"
                          required
                          class="form-control"
                          v-model="register.dob"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Expiry Date<span class="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.expiry_date"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputEmail4">Email</label>
                        <input
                          type="email"
                          class="form-control"
                          v-model="register.email"
                          placeholder="Email"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Phone Number
                          <span class="text-danger">*</span></label
                        >
                        <input v-phone
                          type="text"
                          class="form-control"
                          v-model="register.phone_number"
                          placeholder="Phone Number"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity"
                          >Gender <span class="text-danger">*</span></label
                        >
                        <small v-if="isPregnantCategory" class="text-info d-block mb-1">
                          Locked to Female for Pregnant Women
                        </small>
                        <select
                          class="form-control"
                          required
                          v-model="register.gender"
                          :disabled="isPregnantCategory"
                        >
                          <option value="Male" :disabled="isPregnantCategory">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="sector == 'formal'"
                      >
                        <label class="info-label d-block mb-1" for="inputCity">Select MDA</label>
                        <select
                          class="form-control"
                          v-model="register.place_of_work"
                        >
                          <option
                            :value="mda.name"
                            v-for="mda in mdas"
                            v-bind:key="mda.id"
                          >
                            {{ mda.name }}
                          </option>
                        </select>
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="sector == 'formal'"
                      >
                        <label class="info-label d-block mb-1" for="inputEmail4">Computer Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.salary_number"
                          placeholder="Computer Employment Number"
                        />
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="sector == 'formal'"
                      >
                        <label class="info-label d-block mb-1" for="inputEmail4">Grade Level/Step</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.grade_level"
                          placeholder="Grade Level/Step"
                        />
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="sector == 'formal'"
                      >
                        <label class="info-label d-block mb-1" for="inputPassword4"
                          >Date of First Appointment</label
                        >
                        <date-picker
                          v-model="register.date_of_entry"
                          valueType="format"
                        ></date-picker>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1"
                          >Marital Status
                          <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.marital_status"
                        >
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity"
                          >LGA <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.localgovt"
                          @change="fetchWards($event)"
                        >
                          <option
                            v-for="lga in lga_states"
                            v-bind:key="lga"
                            :value="lga.id"
                          >
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Ward </label>
                        <select
                          class="form-control"
                          v-model="register.ward"
                          @change="getProvidersByWards($event)"
                        >
                          <option
                            v-for="ward in wards"
                            v-bind:key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1"> Facility for Accessing Health Care </label>
                        <v-select
                          v-model="register.provider_id"
                          :options="providers"
                          label="agency_name"
                          :value="register.provider_id"
                        ></v-select>
                        <small v-if="register.localgovt && !(providers || []).length" class="text-muted d-block mt-1">No facility listed for this LGA or ward. Click <b>All</b> to choose from every facility in the state.</small>

                        <button
                          @click="getProviders"
                          type="button"
                          class="btn btn-outline-info btn-sm my-1"
                        >
                          All
                        </button>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Community</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.community"
                          placeholder="Community Name"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Occupation</label>
                        <v-select
                          v-model="register.occupation"
                          :options="occupations"
                          :value="register.occupation"
                        ></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1">Highest Qualification</label>
                        <v-select
                          v-model="register.education"
                          :options="qualifications"
                          :value="register.education"
                        ></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label class="info-label d-block mb-1" for="inputAddress">Home Address</label>
                        <input
                          required
                          type="text"
                          class="form-control"
                          v-model="register.address"
                          placeholder="1234 Main St"
                        />
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="info-label d-block mb-1">Enrollee Photo <span class="text-danger">*</span></label>
                      <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                        Capture Photo <i class="fe fe-camera"></i>
                      </button>
                      <div class="mt-2" v-if="register.user_image">
                        <img
                          :src="register.user_image"
                          class="rounded"
                          style="width:120px;height:120px;object-fit:cover;"
                          alt="Enrollee Photo"
                          onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
                        />
                        <div class="mt-2" v-if="register.user_image && photoOriginal">
                          <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                            <i class="fe fe-crop mr-1"></i> Adjust
                          </button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong
                        >
                      </p>

                      <ul class="declaration-list">
                        <li>
                          I/We hereby declare, on my behalf and on behalf of
                          all persons proposed to be insured that the above
                          statements, answers and/or particulars given by me
                          are true and complete in all respects to the best of
                          my knowledge and that I/We am/ are authorized to
                          propose on behalf of these other persons.
                        </li>
                        <li>
                          I understand that the information provided by me
                          will form the basis of insurance policy, is subject
                          to the Board approved underwriting policy of KGSHIA
                          and that the policy will come into force only after
                          full receipt of the premium chargeable.
                        </li>
                        <li>
                          I/ We further declare that I/We will notify in
                          writing any change occurring in the occupation or
                          general health of the life to be insured/ proposer
                          after the proposal has been submitted but before
                          communication of the risk acceptance by KGSHIA.
                        </li>
                        <li>
                          I/We declare and consent to KGSHIA seeking medical
                          information from any hospital who at any time has
                          attended on the life to be insured/ proposer or from
                          any past or present employer concerning anything
                          which affects the physical and mental health of the
                          life to be assured/proposer and seeking information
                          from any insurance company to which an application
                          for insurance on the life to be assured/ proposer
                          has been made for the purpose of underwriting the
                          proposal and/or claim settlement.
                        </li>
                        <li>
                          I/ We authorize KGSHIA to share information
                          pertaining to my proposal including the medical
                          records for the sole purpose of proposal
                          underwriting and/or claims settlement and with any
                          Governmental and/or Regulatory Authority.
                        </li>
                      </ul>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="declarationAccept"
                            v-model="declarationAccepted"
                          />
                          <label class="form-check-label" for="declarationAccept">
                            I/We have read, understood and accept all of the
                            declarations above
                            <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-submit btn-block">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
            <PhotoCropper ref="photoCropper" />
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import PhotoCropper from "@/components/PhotoCropper.vue";
import occupations from "@/json/occupations.json";
import qualifications from "@/json/qualifications.json";

export default {
  components: { PhotoCropper,
    Loading,
    DatePicker,
  },
  data() {
    return {
      photoOriginal: "",
      isLoading: false,
      fullPage: true,
      states: "",
      show: false,
      clients: "",
      providers: "",
      sector: "informal",
      mdas: "",
      wards: "",
      tpas: "",
      providers_wards: "",
      state: "",
      OfficerDetails: "",
      current_page: "",
      selected_provider: "",
      selected_provider_dependents: "",
      lga_states: "",
      response: "",
      occupations: occupations,
      qualifications: qualifications,
      declarationAccepted: false,
      register: {
        user_image: "",
        firstname: "",
        lastname: "",
        middlename: "",
        nimc_number: "",
        email: "",
        phone_number: "",
        plan_type: "",
        type: "client",
        agency_id: "",
        state: "",
        localgovt: "",
        ward: "",
        address: "",
        community: "",
        occupation: "",
        education: "",
        blood: "",
        weight: "",
        gender: "",
        genotype: "",
        dob: "",
        expiry_date: "",
        salary_number: "",
        provider_id: "",
        point_of_care: "",
        sector: "",
        finger_print: "",
        place_of_work: "",
        org_id: "",
        grade_level: "",
        date_of_entry: "",
        marital_status: "",
        category_of_vulnerable_group: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  computed: {
    categoryLower() {
      return (this.register.category_of_vulnerable_group || '').toLowerCase();
    },
    isChildUnder5Category() {
      return this.categoryLower.includes('under 5');
    },
    isAgedCategory() {
      return this.categoryLower === 'aged' || this.categoryLower === 'pensioners';
    },
    isPregnantCategory() {
      return this.categoryLower.includes('pregnant');
    },
    dobMin() {
      if (this.isChildUnder5Category) {
        const d = new Date();
        d.setFullYear(d.getFullYear() - 5);
        return d.toISOString().slice(0, 10);
      }
      return '1900-01-01';
    },
    dobMax() {
      const today = new Date();
      if (this.isChildUnder5Category) {
        return today.toISOString().slice(0, 10);
      }
      if (this.isAgedCategory) {
        const d = new Date(today);
        d.setFullYear(d.getFullYear() - 60);
        return d.toISOString().slice(0, 10);
      }
      if (this.isPregnantCategory) {
        const d = new Date(today);
        d.setFullYear(d.getFullYear() - 13);
        return d.toISOString().slice(0, 10);
      }
      return today.toISOString().slice(0, 10);
    },
  },
  watch: {
    'register.category_of_vulnerable_group'(newVal) {
      if ((newVal || '').toLowerCase().includes('pregnant')) {
        this.register.gender = 'Female';
      }
    },
  },

  methods: {
    submitForm() {
      if (!this.register.user_image) {
        this.$toasted.error(`Enrollee photo is required`, {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      if (!this.declarationAccepted) {
        this.$toasted.error(`You must accept the declaration to continue`, {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      if (this.user.type == "employee") {
        if (this.register.provider_id != "") {
          this.registerUserEmployee();
        } else {
          this.$toasted.error(`Facility cannot be null`, {
            position: "top-center",
            duration: 3000,
          });
        }
      }

      if (this.user.type == "shis") {
        if (this.register.provider_id != "") {
          this.registerUserAdmin();
        } else {
          this.$toasted.error(`Facility cannot be null`, {
            position: "top-center",
            duration: 3000,
          });
        }
      }
    },
    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${event.target.value}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2669`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerUserAdmin() {
      // console.log(this.selected_provider ? this.selected_provider : this.register.provider_id);
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          user_image: this.register.user_image,
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname.toUpperCase(),
          lastname: this.register.lastname.toUpperCase(),
          middlename: this.register.middlename.toUpperCase(),
          email: this.register.email,
          phone_number: this.register.phone_number,
          plan_type: this.register.plan_type,
          type: this.register.type,
          sectorType: this.sector,
          agency_id: 90,
          provider_id: this.register.provider_id.id,
          state: "2669",
          role: 0,
          password: "euhler",
          org_id: this.register.org_id,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          community: this.register.community,
          occupation: this.register.occupation,
          education: this.register.education,
          blood: this.register.blood,
          dob: this.register.dob,
          expiry_date: this.register.expiry_date,
          address1: this.register.address,
          genotype: this.register.genotype,
          weight: this.register.weight,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work,
          point_of_care: this.register.provider_id.id,
          finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          date_of_entry: this.register.date_of_entry,
          marital_status: this.register.marital_status,
          category_of_vulnerable_group:
            this.register.category_of_vulnerable_group,
          enrolled_by: this.user.id,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Client added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          let user_id = response.data.data.id;

          this.$router.push(`/client/${user_id}`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.response = error.response.data.errors;
        });
    },

    registerUserEmployee() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          user_image: this.register.user_image,
          agency_id: this.user.institutional_id,
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname.toUpperCase(),
          lastname: this.register.lastname.toUpperCase(),
          middlename: this.register.middlename.toUpperCase(),
          email: this.register.email,
          phone_number: this.register.phone_number,
          plan_type: this.register.plan_type,
          type: this.register.type,
          sectorType: this.sector,
          provider_id: this.register.provider_id.id,
          state: "2669",
          role: 0,
          password: "euhler",
          org_id: this.register.org_id,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          community: this.register.community,
          occupation: this.register.occupation,
          education: this.register.education,
          blood: this.register.blood,
          dob: this.register.dob,
          expiry_date: this.register.expiry_date,
          address1: this.register.address,
          genotype: this.register.genotype,
          weight: this.register.weight,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work,
          point_of_care: this.register.provider_id.id,
          finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          date_of_entry: this.register.date_of_entry,
          marital_status: this.register.marital_status,
          category_of_vulnerable_group:
            this.register.category_of_vulnerable_group,
          enrolled_by: this.user.id,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Client added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          let user_id = response.data.data.id;
          this.$router.push(`/client/${user_id}`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.response = error.response.data.errors;
          this.$toasted.error(`${JSON.stringify(this.response)}`, {
            position: "top-center",
            duration: 3000,
          });
        });
    },
    getProviders() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/providerAgency/90`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getProvidersByWards() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(
          `/api/v1/auth/providerAgencies/90/${this.register.localgovt}/${this.register.ward}`
        )
        .then((response) => {
          this.providers = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
    async cropPhoto(src) {
      const cropped = await this.$refs.photoCropper.open(src);
      if (!cropped) return false;
      this.photoOriginal = src;
      this.register.user_image = cropped;
      return true;
    },
    async takePicAndroid() {
      try {
        const image = await Camera.getPhoto({
          quality: 70,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });
        if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
        this.$toasted.info("Photo captured successfully!", {
          position: "top-center",
          duration: 3000,
        });
      } catch (err) {
        if (err && err.message !== "User cancelled photos app") {
          this.$toasted.error("Could not access camera.", {
            position: "top-center",
            duration: 3000,
          });
        }
      }
    },
  },
  created() {
    this.fetchLga();
    this.getProviders();
  },
};
</script>

<style scoped>
/* ── Design-system classes (kgshia has no global design-system.css yet,
     so these are inlined locally to match claimify's shared admin theme) ── */
.table-card { border-radius: 14px !important; border: none !important; overflow: hidden; }
.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
}
.section-number {
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(255, 255, 255, 0.25); color: #fff;
  font-size: 13px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.info-label {
  font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em;
  color: #94a3b8; margin-bottom: 1px; font-weight: 600;
}
.btn-submit {
  background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
  color: #fff !important; border: none !important; border-radius: 8px !important;
  font-weight: 600 !important; transition: opacity 0.15s;
}
.btn-submit:hover, .btn-submit:focus { opacity: 0.9; color: #fff !important; }
.declaration-list { padding-left: 1.2rem; font-size: 0.9rem; color: #475569; }
.declaration-list li { margin-bottom: 8px; }
</style>
